const INITIAL_STATE = {
  data: {},
  errors: {},
}
  
const getCommercialWorkOrder = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_COM_WORK_ORDER':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_COM_WORK_ORDER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default getCommercialWorkOrder;
  